import { render, staticRenderFns } from "./OccurrenceSelectDb.vue?vue&type=template&id=45c7abde"
import script from "./OccurrenceSelectDb.ts?vue&type=script&lang=ts&external"
export * from "./OccurrenceSelectDb.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports